import { withApiBaseUrl } from '../lib/apiBaseUrl'
import { getRuntimeTenantIdSync } from '../lib/runtimeTenant'
import { handleUnauthorizedResponse } from '../utils/sessionReplacedHandler'
import * as authService from './authService'
import {
  isMonthlyRewardTabUnavailableMessage,
  MONTHLY_REWARD_UNAVAILABLE_TEXT,
} from '../utils/monthlyRewardTabs'

function getTenantId(): string {
  const user = authService.getCurrentUser()
  return user?.tenantId || getRuntimeTenantIdSync() || ''
}

export type MonthlyRewardTabKey = 'cashback' | 'loss' | 'refer' | 'rank'

export interface MonthlyRewardItem {
  rank: number
  user: string
  metricValue: string
  reward: string
  source: 'real' | 'fake'
}

export interface MonthlyRewardResponse {
  success: boolean
  data?: {
    tab: MonthlyRewardTabKey
    monthLabel: string
    pageTitle: string
    subtitle: string
    title: string
    metricLabel: string
    rewardLabel: string
    emptyText: string
    items: MonthlyRewardItem[]
    summary?: {
      realCount: number
      fakeCount: number
      rowsPerTab: number
    }
    fakeDataRotationHours?: 1 | 3 | 6
    fakeDataRotatesAt?: string
    updatedAt?: string | null
    updatedBy?: string | null
  }
  message?: string
}

export async function getMonthlyRewardBoard(tab: MonthlyRewardTabKey): Promise<MonthlyRewardResponse> {
  const token = authService.getAccessToken()
  const tenantId = getTenantId()
  const res = await fetch(withApiBaseUrl(`/api/v1/user-auth/monthly-rewards/${tab}`), {
    method: 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(tenantId ? { 'X-Tenant-ID': tenantId } : {}),
    },
    credentials: 'include',
  })

  const data = await res.json().catch(() => ({ success: false, message: 'Invalid monthly reward response' }))
  if (await handleUnauthorizedResponse(res.status, data)) {
    throw new Error((data as { code?: string })?.code === 'SESSION_REPLACED' ? 'SESSION_REPLACED' : 'AUTH_EXPIRED')
  }
  if (
    res.status === 404 &&
    isMonthlyRewardTabUnavailableMessage((data as MonthlyRewardResponse)?.message)
  ) {
    return {
      success: true,
      data: {
        tab,
        monthLabel: 'เดือนปัจจุบัน',
        pageTitle: 'รางวัลประจำเดือน',
        subtitle: '',
        title: 'รางวัลประจำเดือน',
        metricLabel: '',
        rewardLabel: '',
        emptyText: MONTHLY_REWARD_UNAVAILABLE_TEXT,
        items: [],
      },
    }
  }
  if (!res.ok) {
    throw new Error((data as any)?.message || `HTTP ${res.status}`)
  }
  return data as MonthlyRewardResponse
}
